import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import classes from "./helpmobile.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import {
  HeadingBg,
  CapIconRed,
  HelpStarIcon,
} from "../../../constant/imagePath";
import { CommonQuestions } from "../../../stories/CommonQuestions/CommonQuestions";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter.jsx";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader.jsx";
import InputCssClasses from "../../../stories/Input/input.module.css";
import CommonQuestionsCssClasses from "../../../stories/CommonQuestions/commonQuestions.module.css";
import MobileHelpSearchModal from "../../../components/Modals/GeneralScreen/MobileHelpSearchModal/MobileHelpSearchModal.jsx";
import useDebounce from "../../../CustomHooks/useDebounce.jsx";

const HelpMobile = () => {
  const [search, setSearch] = useState("");

  const [selectedRole, setSelectedRole] = useState(null);
  const [showSearchModal, setShowSearchModal] = useState(false);

  const [searchArray, setSearchArray] = useState([]);

  const debouncedSearch = useDebounce(search, 500);

  // useEffect(() => {
  //     setSearchArray(
  //         staticSearchArray.find((item) => item?.categories?.includes(search))?.title
  //     );
  // }, [search]);

  const cards = [
    {
      title: "Students",
      icon: CapIconRed,
      description:
        "Find out more about the student's profile and all the nuances of booking a lesson.",
    },
    {
      title: "Coaches",
      icon: HelpStarIcon,
      description:
        "Learn all about registration, profile management and other features.",
    },
  ];

  const staticSearchArray = [
    {
      title: "Coaches",
      categories: [
        {
          title: "How does LyteSnap work?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How do I become a LyteSnap Coach? ",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "Keys for an outstanding coach application",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "Am I eligible to be a LyteSnap Coach?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
      ],
    },
    {
      title: "Students",
      categories: [
        {
          title: "How do I find a coach and get started?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How much does it cost to book training sessions?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How can I reset my password or email?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
      ],
    },
  ];

  // On Search
  function onSubmitSearch({ searchValue }) {
    setSearch(searchValue);
  }

  useEffect(
    () => {
      if (debouncedSearch) {
        if (showSearchModal == false) {
          const roleIndex = staticSearchArray.findIndex((item) =>
            item?.title?.includes(selectedRole)
          );
          const searchObject = staticSearchArray[roleIndex].categories.find(
            (item) => item?.title?.includes(search)
          );
          setSearchArray([
            {
              title: selectedRole,
              categories: [searchObject],
            },
          ]);
        } else {
          setSearchArray(staticSearchArray);
        }
      } else {
        setSelectedRole(null);
        setSearchArray(staticSearchArray);
      }
    },
    [debouncedSearch] // Only call effect if debounced search term changes
  );
  return (
    <>
      <style jsx>{`
        .${InputCssClasses.inputBox} {
          padding: 16px;
        }
        .${CommonQuestionsCssClasses.commonQuestions} h4 {
          margin: 24px 0px;
        }
        .accordion-button {
          padding: 24px 0px 16px 0px !important;
        }
      `}</style>
      <div className={classes.helpPage}>
        <div className="container-fluid" style={{ padding: "0px" }}>
          <Row className="g-0">
            <Col
              md={12}
              style={{
                backgroundColor: Colors.neutralShadesOfWhiteSmoke,
                padding: "16px 16px 0px",
              }}
            >
              <Row className={`gx-0 ${classes.howCanWeHelp}`}>
                <Col md={12} className={classes.header}>
                  <MobileHeader
                    isAvatar={true}
                    isLogo={true}
                    //   customStyle={{
                    //     maxWidth: "100%",
                    //   }}
                  />
                </Col>
                <Col md={12}>
                  <h2
                    style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
                  >
                    How can we{" "}
                    <span style={{ position: "relative" }}>
                      help? &nbsp; &nbsp; <img src={HeadingBg} />
                    </span>
                  </h2>
                </Col>
                <Col md={12}>
                  <div
                    className={classes.searchBox}
                    onClick={() => {
                      setShowSearchModal(!showSearchModal);
                    }}
                  >
                    <span
                      style={{
                        ...Fonts.p1,
                        color:
                          search == ""
                            ? Colors.neutralShadesOfDimGray
                            : Colors.neutralShadesOfNero,
                      }}
                    >
                      {search == "" ? "Search Lytesnap help center" : search}
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
            {/* Main Content */}
            <Col md={12} className={classes.mainContent}>
              <Row className="g-0">
                {selectedRole == null ? (
                  cards?.map((item) => {
                    return (
                      <Col md={12}>
                        <div
                          className={classes.card}
                          style={{
                            border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                          }}
                          onClick={() => {
                            setSelectedRole(item?.title);
                          }}
                        >
                          <div className={classes.cardIcon}>
                            <img src={item?.icon} />
                          </div>
                          <h5
                            style={{
                              ...Fonts.h5,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            {item?.title}
                          </h5>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfDimGray,
                            }}
                          >
                            {item?.description}
                          </p>
                        </div>
                      </Col>
                    );
                  })
                ) : (
                  <Col md={12}>
                    {/* Breadcrumb */}
                    <p
                      style={{
                        ...Fonts.p1,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                    >
                      Lytesnap Help Center
                      {selectedRole && ` / ${selectedRole}`}{" "}
                      {search && ` / ${search}`}
                    </p>
                    {searchArray?.map((item, index) => {
                      return (
                        <CommonQuestions
                          heading={item?.title}
                          data={item?.categories}
                        />
                      );
                    })}

                    {/* <CommonQuestions
                                            heading="Becoming a LyteSnap Coach"
                                            data={searchArray}
                                        />
                                        <CommonQuestions
                                            heading="Managing My Account"
                                            data={[
                                                {
                                                    title: "How do I set my availability?",
                                                    description:
                                                        "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
                                                },
                                                {
                                                    title: "Why might my background check not be verified?",
                                                    description:
                                                        "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
                                                },
                                            ]}
                                        /> */}
                  </Col>
                )}
              </Row>
            </Col>
            <Col md={12} className="footerContainer">
              <MobileFooter />
            </Col>
          </Row>
        </div>
      </div>
      <MobileHelpSearchModal
        show={showSearchModal}
        setShow={setShowSearchModal}
        searchText={search}
        setSearchText={setSearch}
        SearchArray={searchArray}
        setRole={setSelectedRole}
      />
    </>
  );
};
export default HelpMobile;
